export default __webpack_public_path__ + "static/media/7.28cd8d25.png";